import { useMemo, useState } from "react";
import {
  MyOrderStatusColors,
  MyPaymentStatusColors,
} from "../../../../constants/order-status-enums";

import DetailModal from "./DetailModal/DetailModal";
import styles from "./Item.module.css";
import { useTranslation } from "react-i18next";
import { Uniter } from "../../../../helbest";
import { Button } from "antd";
import { useLangNavigate } from "../../../../hooks/useLangNavigate";

const Item = (props) => {
  const navigate = useLangNavigate();
  const { id, created, status, payment_status, payable_amount, currency } = props;
  const [orderData, setOrderData] = useState({ id, created, payable_amount });
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className={styles.BoxItem} key={id}>
      <div className={styles.Content}>
        <div>
          <span className={styles.ContentTitle}>{t("summary.order_date")}</span>
          <span>{created}</span>
        </div>
        <div>
          <span className={styles.ContentTitle}>
            {t("detailmodel.order_status")}
          </span>
          <span style={{ color: MyOrderStatusColors[status] }}>
            {t(`order.${status}`)}
          </span>
        </div>
        <div>
          <span className={styles.ContentTitle}>
            {t("detailmodel.payment_status")}
          </span>
          <span style={{ color: MyPaymentStatusColors[payment_status] }}>
            {t(`order.${payment_status}`)}
          </span>
        </div>
        <div className={styles.PaidAmount}>
          {t("summery.payable")}
          <Uniter unit={currency} isBold unit_bold>
            {payable_amount}
          </Uniter>
        </div>
      </div>
      <div className={`${styles.Seprator} mt-1`} />
      <div className="w-full flex justify-between items-center">
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            width: "100%",
            marginInline: "8px",
          }}
        >
          <Button
            type="primary"
            onClick={(e) => {
              navigate(`/my-order/${id}`);
            }}
          >
            {t("detailmodel.order_details")}
          </Button>
        </div>
      </div>
      {orderData !== null && (
        <DetailModal open={open} setOpen={setOpen} data={orderData} />
      )}
    </div>
  );
};

export default Item;